import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff, toDecimal, getPowerDownDateDiff, timestampToTime, formatDate } from "../../unit/public";
import dsteem from "../../unit/DsteemUtil";
import { ElMessage, ElLoading } from "element-plus";
export default {
  name: "TradingOrderList",
  props: {
    tradingData: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    loginData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      currentOrderId: "",
      currentUser: "",
      isLoginError: false,
      acitveKey: "",
      isLogining: false,
      errorMessage: ""
    };
  },
  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.type === "buy") {
        return "buy";
      } else if (row.type === "sell") {
        return "sell";
      }

      return "";
    },
    cancelOrder: function cancelOrder() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, myAccount, op, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.acitveKey) {
                  _context.next = 4;
                  break;
                }

                _this.errorMessage = "activeKeyError";
                _this.isLoginError = true;
                return _context.abrupt("return");

              case 4:
                _this.isLogining = true;
                that = _this;
                myAccount = _this.loginData[0];
                op = ["limit_order_cancel", {
                  owner: myAccount,
                  orderid: _this.currentOrderId
                }];
                _context.prev = 8;
                _context.next = 11;
                return dsteem.sendOperations([op], _this.acitveKey);

              case 11:
                result = _context.sent;

                if (result && result.block_num) {
                  _this.isLoginError = false;
                  _this.errorMessage = "";
                  _this.isLogining = false;
                  _this.dialogVisible = false;
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                }

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](8);

                if (_context.t0.jse_info.code == 10) {
                  _this.isLoginError = true;
                  _this.errorMessage = "balanceError";
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                } //


              case 18:
                _this.isLogining = false;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 15]]);
      }))();
    },
    handleCancel: function handleCancel(row) {
      console.log(row);
      this.currentOrderId = row.orderId;
      this.currentUser = row.seller;

      if (this.loginData[4] == "true") {
        var that = this;
        var myAccount = this.loginData[0];
        var op = [["limit_order_cancel", {
          owner: myAccount,
          orderid: this.currentOrderId
        }]];
        window.steem_keychain.requestBroadcast(myAccount, op, "active", function (response) {
          if (response.success) {
            ElMessage({
              message: that.$t("success.tradeSuccess"),
              type: "success"
            });
          } else {
            ElMessage({
              message: that.$t("error.transError"),
              type: "error"
            });
          }
        });
      } else {
        this.dialogVisible = true;
      }
    }
  }
};